(() => {
  if (window.HeritageAboutMotion) return;
  window.HeritageAboutMotion = true;

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const observer = 'IntersectionObserver' in window && !reducedMotion.matches
    ? new IntersectionObserver((entries, instance) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-in-view');
          instance.unobserve(entry.target);
        });
      }, { threshold: 0.08, rootMargin: '0px 0px -24px 0px' })
    : null;

  const observe = (root = document) => {
    const sections = root.matches?.('[data-about-reveal="true"]')
      ? [root]
      : root.querySelectorAll('[data-about-reveal="true"]');
    sections.forEach((section) => {
      if (section.classList.contains('is-in-view')) return;
      if (observer) observer.observe(section);
      else section.classList.add('is-in-view');
    });
  };

  const ready = () => observe();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready, { once: true });
  else ready();

  document.addEventListener('shopify:section:load', (event) => observe(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    if (!observer) return;
    event.target.querySelectorAll('[data-about-reveal="true"]').forEach((section) => observer.unobserve(section));
  });
})();
